import { useMemo } from 'react';
import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { isInJsmGlobalSettingsBoundary } from '@atlassian/jira-platform-ui-banners-jsm-packaging-updates/src/controllers/utils.tsx';

export const useJsmGracePeriodBanner = () => {
	const currentRoute = useCurrentRoute();
	const { data: project } = useProjectContext();

	const isServiceProject = project?.projectType === SERVICE_DESK_PROJECT;
	const isInJsmBoundary = useMemo(
		() => isInJsmGlobalSettingsBoundary(currentRoute.path) || isServiceProject,
		[isServiceProject, currentRoute.path],
	);

	return useMemo(
		() => ({
			isEnabled: isInJsmBoundary && fg('jsm_gp_announcements_banner'),
		}),
		[isInJsmBoundary],
	);
};
